import {Provider, computed, inject} from '@angular/core';
import {TableDateSettings} from '@innobile/tablemodule';
import {DateFormatService} from './date-format.service';
import {TABLE_DATE_FORMATS} from './date-format.constants';

/**
 * tablemodule's date cells in the selected company's zone and display format, like the rest of the
 * app: `2026.09.04 15:42`, or `Sep 4 3:42 pm` for a US company (`Sep 4 2025 3:42 pm` outside the
 * current year). Without a company zone the table falls back to the browser's.
 */
export function provideTableDateSettings(): Provider {
  return {
    provide: TableDateSettings,
    useFactory: (): TableDateSettings => {
      const dateFormat = inject(DateFormatService);
      return {
        timezone: computed(() => dateFormat.timezone() ?? undefined),
        formats: computed(() => TABLE_DATE_FORMATS[dateFormat.profile()]),
        // Like period-selector9's fields: the US format drops the year inside the current one.
        omitCurrentYear: computed(() => dateFormat.profile() === 'us'),
      };
    },
  };
}
